module.exports = __webpack_public_path__ + "img/5.c78a5e2c.jpg";